import(/* webpackMode: "eager" */ "/vercel/path0/app/partner/page.tsx");
